import styled from "styled-components";

/**
 * Wrapper do componente FlightPrice
 * Configura o layout principal do componente.
 */
export const StyledFlightPrice = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.large};
  box-shadow: ${({ theme }) => theme.shadows.light.medium};
  background-color: ${({ theme }) => theme.colors.darkBlue};
  min-width: ${({ theme }) => theme.spacing(25)};
  justify-content: center;
  flex-direction: column;
  align-items: center;
  display: flex;
`;

/**
 * Wrapper do preço
 * Define o layout para exibir o preço formatado.
 */
export const PriceWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(2)};
  display: flex;
`;

/**
 * Botão "Veja Mais"
 * Configura o layout e o estilo do botão de ação.
 */
export const SeeMoreButton = styled.div`
  border-radius: 0 0 ${({ theme }) => theme.borderRadius.large}
    ${({ theme }) => theme.borderRadius.large};
  background-color: ${({ theme }) => theme.colors.yellow};
  padding: ${({ theme }) => theme.spacing(2)};
  gap: ${({ theme }) => theme.spacing(1)};
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
`;
